import { selectAudioToPlay } from '@vh/slices/chat/ChatSlice';
import { usePrevious } from '@vh/utility/StateHooks';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

const useLatestTTSFriendlyVHText = () => {
  const audioToPlay = useSelector(selectAudioToPlay);
  const prevAudioToPlay = usePrevious(audioToPlay);

  const latestText = useMemo(() => {
    if (audioToPlay && !prevAudioToPlay) {
      try {
        const parsed = JSON.parse(audioToPlay);
        return parsed?.response?.ttsLocaleFriendlyText;
      } catch (e) {
        console.error(e);
      }
    }
    return null;
  }, [audioToPlay, prevAudioToPlay]);

  return latestText;
};

/** @type {(onNewVHText: (newText: string) => void) => void} */
export const useOnNewTTSFriendlyVHText = (onNewVHText) => {
  const latestText = useLatestTTSFriendlyVHText();
  const prevText = usePrevious(latestText);
  useEffect(() => {
    if (latestText && latestText !== prevText) {
      onNewVHText(latestText);
    }
  }, [latestText, onNewVHText, prevText]);
};
